<template>
  <ComboBox
    :ref="refName"
    :data="sortedData"
    :prefix="prefix"
    :isItemChecked="isDestinationChecked"
    @checkClick="updatePort"
    @doSearch="doSearchDestination"
    :isSelectAll="false"
    :selectAll="() => {}"
    :deSelectAll="() => {}"
    :multi="false"
    :selected="
      destination && destination.name
        ? [{ value: destination.name, id: destination.id }]
        : []
    "
    :showValues="true"
    @removeItem="removeDestination"
    :errorMessage="''"
    :showLabel="false"
    :isLoading="isSearching"
    :placeholder="placeholder"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ComboBox from "./ComboBox.vue";
export default {
  components: {
    ComboBox,
  },
  name: "PortsComboBox",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    refName: {
      type: String,
      default: "",
    },
    destination: {
      type: Object,
      default: () => {},
    },
    prefix: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sortedData: [],
      isSearching: false,
    };
  },
  methods: {
    ...mapActions(["searchPorts"]),
    debounceSearch: function (fn, delay) {
      return (...args) => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    },
    updatePort(item) {
      this.$emit("updatePort", item);
      // Clear the input field
      if (this.$refs[this.refName]) {
        const input =
          this.$refs[this.refName].$el.querySelector('input[type="text"]');
        if (input) {
          input.value = "";
          // Trigger any necessary events
          const event = new Event("input", { bubbles: true });
          input.dispatchEvent(event);
        }
      }
    },
    removeDestination(id) {
      if (this.destination && this.destination.id === id) {
        this.$emit("updatePort", {});
        this.sortedData = this.data;
      }
    },
    doSearchDestination: function ({ target: { value } }) {
      if (value.length < 2) {
        return (this.sortedData = this.data);
      }
      this.isSearching = true;
      this.sortedData = this.data.filter((d) =>
        d.name.toLowerCase().includes(value.toLowerCase())
      );

      this.debounceSearch(async (searchTerm) => {
        try {
          const results = await this.searchPorts({
            keyword: searchTerm,
            type: this.getShipmentType,
          });
          const ports =
            results?.data?.payload?.data?.map((item) => ({
              country: item.country,
              entry: "port",
              name: `${item.name} (${
                this.getShipmentType === "air" ? "airport" : "sea port"
              }) - ${item.locode.toUpperCase()}`,
              personOfContact: "",
              port: item.id,
              address: item.address,
            })) || [];
          this.sortedData = [...ports, ...this.sortedData];
        } catch (error) {
          console.error("Error searching ports:", error);
          this.sortedData = [...this.data];
        } finally {
          this.isSearching = false;
        }
      }, 700)(value);
    },
    isDestinationChecked(item) {
      return this.destination && this.destination.id === item.id;
    },
  },
  computed: {
    ...mapGetters(["destinations", "origins", "users", "getShipmentType"]),
  },
  watch: {
    data: {
      handler() {
        this.sortedData = this.data;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style></style>
